/**
 * Badge de statut assessment — pattern SkillMap V0.
 */
import { useTranslation } from "react-i18next";

export type AssessmentStatus = "draft" | "submitted" | "validated";

const CLASS: Record<AssessmentStatus, string> = {
  draft: "sm-badge-pill sm-badge-gray",
  submitted: "sm-badge-pill sm-badge-yellow",
  validated: "sm-badge-pill sm-badge-green",
};

export function StatusBadge({ status }: { status: AssessmentStatus }) {
  const { t } = useTranslation();
  return <span className={CLASS[status]}>{t(`status_${status}`)}</span>;
}
